let timeoutId
/**
 * This detects single/double click and execute appropriate handler passed in options
 * This function is supposed to be called as callback to click event
 * @param {onSingleClick: Function, onDoubleClick: Function}
 */
export default options => {
  if (!timeoutId) {
    timeoutId = setTimeout(() => {
      timeoutId = null
      const selectedText = window.getSelection().toString()
      if (!selectedText && options.onSingleClick) {
        options.onSingleClick()
      }
    }, 200) //tolerance in ms
  } else {
    clearTimeout(timeoutId)
    timeoutId = null
    options.onDoubleClick()
  }
}
